export default {
  state: {
    appStartupStep: null, // app启动步骤：0-刚启动，1-同意隐私协议，2-显示广告中，3-开屏广告结束
    elderModeEnum: '', //长辈模式，1-开启,0-关闭
    touristMode: false // 游客模式
  },
  mutations: {
    saveAppStartupStep(state, val) {
      state.appStartupStep = val
    },
    saveElderModeEnum(state, data) {
      state.elderModeEnum = data
    },
    // 游客模式
    updateTouristMode(state, data) {
      state.touristMode = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/test.js